/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { deleteRttMessage, initializeRttMessageState, newRttMessage, updateRttMessage } from '../+state/message.actions';
import { Message } from 'CalltakingCoreApi';
import { MessageService } from './message.service';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
    providedIn: 'root'
})
export class RttMessageService extends MessageService {
    constructor(
        private http: HttpClient,
        protected store: Store,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected stompManager: StompManagerService
    ) {
        super('RTT', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_RTT_NEW, Topic.MESSAGES_RTT_EDIT, Topic.MESSAGES_RTT_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any, clusterName: string) => void } {
        return {
            [Topic.MESSAGES_RTT_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_RTT_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_RTT_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {}

    protected websocketInitialized(clusterName: string): void {
        this.store.dispatch(initializeRttMessageState({ clusterName: clusterName }));
    }

    protected deleteMessage(message: Message, clusterName: string): void {
        this.store.dispatch(deleteRttMessage({ message, clusterName }));
    }

    protected editMessage(message: Message, clusterName: string): void {
        this.store.dispatch(updateRttMessage({ message, clusterName }));
    }

    protected newMessage(message: Message, clusterName: string): void {
        this.store.dispatch(newRttMessage({ message, clusterName }));
    }

    public requestRttMessages(callId: string, clusterName: string) {
        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, `${this.API_BASE_URL}${callId}/load/${this.type}`);
        return this.http.get<Message[]>(url, { observe: 'body', responseType: 'json' });
    }
}
